import { render, staticRenderFns } from "./PropertyEditorGroup.vue?vue&type=template&id=27d0a164&"
import script from "./PropertyEditorGroup.vue?vue&type=script&lang=js&"
export * from "./PropertyEditorGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports